<template>
    <div class="new-project">
        <ProjectsDialog :isDialogOpened="dialog"
        v-on:dialogClosed="closeDialog">
            <div slot="activator"
                 class="new-project__btn"
                 v-ripple
                 @click="createNewProject()">
                <i class="material-icons new-item__icon">add</i>
            </div>
        </ProjectsDialog>
        <h2 class="new-item__title">Add a project</h2>
    </div>
</template>

<script>
    import ProjectsDialog from "./ProjectsDialog";

    export default {
        name: "NewProjectItemItem",
        props: ['isDialogOpened', 'domain_id'],
        components: {ProjectsDialog},
        data: () => ({
            newProject: null,
            dialog: null
        }),
        methods: {
            createNewProject() {
                this.$router.push({name: 'NewProjectForm', params: {domain_id: this.domain_id}});
                this.dialog = true;
            },
            closeDialog(){
                this.dialog = false;
                this.$emit('dialogClosed')
            }
        },
        watch: {
            isDialogOpened: function (val, oldVal) {
                if (val === undefined) {
                    this.dialog = true;
                } else {
                    this.dialog = val;
                }
            }
        }
    }
</script>

<style scoped>

</style>
